import { render, staticRenderFns } from "./AppRoomIcon.vue?vue&type=template&id=a5fb8e42&scoped=true&"
import script from "./AppRoomIcon.vue?vue&type=script&lang=js&"
export * from "./AppRoomIcon.vue?vue&type=script&lang=js&"
import style0 from "./AppRoomIcon.vue?vue&type=style&index=0&id=a5fb8e42&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fb8e42",
  null
  
)

export default component.exports